import { Link } from 'react-router-dom';
import { newsArticles } from '@/mocks/newsArticles';
import { formatDateCn } from '@/utils/format';

export default function LatestNews() {
  const feature = newsArticles[1];
  const rest = newsArticles.slice(2, 6);

  return (
    <section className="bg-background-50">
      <div className="mx-auto w-full px-4 py-10 md:px-8 md:py-14">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="text-xs tracking-[0.24em] text-primary-600">NEWS & STORIES</p>
            <h2 className="mt-2 font-heading text-xl text-foreground-950 md:text-2xl">最新动态</h2>
          </div>
          <Link
            to="/category/news"
            className="flex items-center gap-1 whitespace-nowrap text-sm text-foreground-500 transition-colors hover:text-primary-600"
          >
            查看全部动态
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-line" />
            </span>
          </Link>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-12 lg:gap-8">
          <Link
            to={`/detail/news/${feature.id}`}
            className="group relative block overflow-hidden rounded-lg border border-background-200 lg:col-span-7"
          >
            <div className="h-[240px] w-full overflow-hidden bg-background-200 sm:h-[300px] md:h-[360px]">
              <img
                src={feature.image}
                alt={feature.title}
                title={`${feature.title} - 禁止的爱善良的小姨子动态`}
                className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.03]"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/92 via-foreground-950/45 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
              <div className="flex flex-wrap items-center gap-3 text-xs">
                <span className="rounded-sm bg-accent-500 px-2 py-0.5 text-primary-950">{feature.category}</span>
                <span className="text-background-100/70">{formatDateCn(feature.date)}</span>
              </div>
              <h3 className="mt-3 font-heading text-lg leading-snug text-background-50 md:text-2xl">
                {feature.title}
              </h3>
              <p className="mt-2 hidden max-w-xl text-sm leading-relaxed text-background-100/75 sm:block">
                {feature.summary}
              </p>
            </div>
          </Link>

          <div className="flex flex-col divide-y divide-background-200 border-t border-background-200 lg:col-span-5 lg:border-t-0">
            {rest.map((article) => (
              <Link
                key={article.id}
                to={`/detail/news/${article.id}`}
                className="group flex gap-4 py-4 first:pt-0 lg:first:pt-4"
              >
                <div className="h-[74px] w-[104px] shrink-0 overflow-hidden rounded-md bg-background-200 sm:h-[84px] sm:w-[124px]">
                  <img
                    src={article.image}
                    alt={article.title}
                    title={`${article.title} - 禁止的爱善良的小姨子动态`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="text-[11px] text-primary-500">{article.category}</p>
                  <h3 className="mt-1 line-clamp-2 font-heading text-sm leading-snug text-foreground-900 transition-colors group-hover:text-primary-600 md:text-[15px]">
                    {article.title}
                  </h3>
                  <p className="mt-2 text-[11px] text-foreground-400">{formatDateCn(article.date)}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}